
import React from "react";
import { ApiKeyManager } from "@/components/dashboard/ApiKeyManager";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function AiConnections() {
  return (
    <div className="container mx-auto p-4 md:p-6">
      <h1 className="text-3xl font-bold mb-6">AI Connections</h1>
      <p className="text-muted-foreground mb-6">
        Connect your AI provider accounts to use their models with OGMAI.
      </p>
      
      <Card className="mb-6">
        <CardHeader>
          <CardTitle>API Key Configuration</CardTitle>
          <CardDescription>
            Add your API keys for LLM models that will be used by agents.
            Your keys are encrypted and never shared.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ApiKeyManager />
        </CardContent>
      </Card>
    </div>
  );
}
